
import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { SignalRTypes, SportTypesActionTypes } from '../actions';
import { Enums } from "../../helpers";

export function* requests() {

    yield takeEvery(SignalRTypes.Main_Tournament_Events_Response, function* ({ response }) {
        try {

            window.console.response("RES Main_Tournament_Events", response);

            switch (response.status) {
                case 1:
                    yield put({
                        type: SportTypesActionTypes.Main_Tournament_Events_Success,
                        mainTournamentEvents: response.data,
                    })
                    
                    break;

                case 3:
                    yield put({
                        type: SportTypesActionTypes.Main_Tournament_Events_Error,
                        error: response.message,
                    })
                    break;

            }

        }
        catch (e) {
            window.log("ERROR", e)

        }
    })
}
export default function* MainTournamentSaga() {
    yield all([
        fork(requests),
    ])
}
